/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ats_Tip_Add_SkillsInputs */

const en_ats_tip_add_skills = /** @type {(inputs: Ats_Tip_Add_SkillsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add a skills section with relevant keywords from the job description`)
};

const de_ats_tip_add_skills = /** @type {(inputs: Ats_Tip_Add_SkillsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Füge einen Kompetenzbereich mit relevanten Keywords aus der Stellenbeschreibung hinzu`)
};

const fr_ats_tip_add_skills = /** @type {(inputs: Ats_Tip_Add_SkillsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ajoutez une section compétences avec des mots-clés pertinents de l'offre d'emploi`)
};

const es_ats_tip_add_skills = /** @type {(inputs: Ats_Tip_Add_SkillsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Añade una sección de habilidades con palabras clave relevantes de la descripción del puesto`)
};

const it_ats_tip_add_skills = /** @type {(inputs: Ats_Tip_Add_SkillsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aggiungi una sezione competenze con parole chiave pertinenti dalla descrizione del lavoro`)
};

const nl_ats_tip_add_skills = /** @type {(inputs: Ats_Tip_Add_SkillsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voeg een vaardigheidssectie toe met relevante trefwoorden uit de vacaturetekst`)
};

const pl_ats_tip_add_skills = /** @type {(inputs: Ats_Tip_Add_SkillsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dodaj sekcję umiejętności z odpowiednimi słowami kluczowymi z opisu stanowiska`)
};

const fi_ats_tip_add_skills = /** @type {(inputs: Ats_Tip_Add_SkillsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lisää osaamisosio työpaikkailmoituksen relevanteilla avainsanoilla`)
};

const da_ats_tip_add_skills = /** @type {(inputs: Ats_Tip_Add_SkillsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tilføj en kompetencesektion med relevante søgeord fra jobbeskrivelsen`)
};

const sv_ats_tip_add_skills = /** @type {(inputs: Ats_Tip_Add_SkillsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lägg till en kompetenssektion med relevanta nyckelord från jobbeskrivningen`)
};

/**
* | output |
* | --- |
* | "Add a skills section with relevant keywords from the job description" |
*
* @param {Ats_Tip_Add_SkillsInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const ats_tip_add_skills = /** @type {((inputs?: Ats_Tip_Add_SkillsInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ats_Tip_Add_SkillsInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_ats_tip_add_skills(inputs)
	if (locale === "fr") return fr_ats_tip_add_skills(inputs)
	if (locale === "es") return es_ats_tip_add_skills(inputs)
	if (locale === "it") return it_ats_tip_add_skills(inputs)
	if (locale === "nl") return nl_ats_tip_add_skills(inputs)
	if (locale === "pl") return pl_ats_tip_add_skills(inputs)
	if (locale === "fi") return fi_ats_tip_add_skills(inputs)
	if (locale === "da") return da_ats_tip_add_skills(inputs)
	if (locale === "sv") return sv_ats_tip_add_skills(inputs)
	return en_ats_tip_add_skills(inputs)
});